export const START_TEAM_GUESS_GAME_COMPLETED = "teamGuess/startGameCompleted";
export const GUESS_TEAM_COMPLETED = "teamGuess/guessTeamCompleted";
export const GET_TEAM_GUESS_STATUS_COMPLETED = "teamGuess/getGameStatusCompleted";
export const GET_TEAM_SUGGESTIONS_COMPLETED = "teamGuess/getTeamSuggestionsCompleted";
export const CLEAR_TEAM_SUGGESTIONS = "teamGuess/clearTeamSuggestions";
